<template>
    <div class="flex flex-col justify-center items-center mt-16">
        <img :src="emptyStates[currentState]['imgSrc']" class="z-10 w-24 mb-5" :alt="trans('calendar.calendar_drawer.empty_state')">
        <i v-if="emptyStates[currentState]['icon']" :class="emptyStates[currentState]['icon']" class="icon-container"></i>
        <h4 class="mb-2 font-bold">{{ emptyStates[currentState]['title'] }}</h4>
        <p class="mb-0 text-center text-blue-500">{{ emptyStates[currentState]['message'] }}</p>
    </div>
</template>

<script>
    export default {
        props: {
            currentState: {
                type: String,
                required: true,
            }
        },

        computed: {
            iconSuffix() {
                return this.$store.getters.isNordhealthBrand ? 'Nordhealth' : '';
            },

            emptyStates() {
                return {
                    appointmentNotSelected: {
                        imgSrc: `/images/calendar/drawerEmptyStateIcon${this.iconSuffix}.svg`,
                        title: trans('calendar.calendar_drawer.appointment_not_selected'),
                        message: trans('calendar.calendar_drawer.please_select_client_appointment')
                    },

                    noJournalEntries: {
                        imgSrc: `/images/calendar/drawerNoEntriesIcon${this.iconSuffix}.svg`,
                        title: trans('calendar.calendar_drawer.no_journal_entries'),
                        message: trans('calendar.calendar_drawer.client_no_entries')
                    },

                    noJournalFiles: {
                        imgSrc: `/images/calendar/drawerNoEntriesIcon${this.iconSuffix}.svg`,
                        title: trans('client.no_journal_files'),
                        message: trans('client.journal_files_empty')
                    },

                    noInvoices: {
                        imgSrc: `/images/calendar/drawerNoEntriesIcon${this.iconSuffix}.svg`,
                        title: trans('calendar.calendar_drawer.no_invoices_available'),
                        message: trans('calendar.calendar_drawer.client_no_invoices')
                    },

                    noAccessJournals: {
                        imgSrc: `/images/calendar/drawerNoAccessIcon${this.iconSuffix}.svg`,
                        title: trans('calendar.calendar_drawer.no_journal_access'),
                        message: trans('calendar.calendar_drawer.journal_access_info_text')
                    },

                    noAccessInvoices: {
                        imgSrc: `/images/calendar/drawerNoAccessIcon${this.iconSuffix}.svg`,
                        title: trans('calendar.calendar_drawer.no_invoices_access'),
                        message: trans('calendar.calendar_drawer.invoices_access_info_text')
                    },

                    noTasks: {
                        imgSrc: `/images/calendar/drawerNoTasksIcon${this.iconSuffix}.svg`,
                        title: trans('calendar.calendar_drawer.no_tasks_available'),
                        message: trans('calendar.calendar_drawer.client_no_tasks'),
                    }
                }
            }
        },
    };
</script>
